import { ToastStateHandler, UserApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';
import { ICallback } from '../../../commonTypes/hook.types';

const useHttpDeleteMedicalLeaveRequest = () => {
    const { t } = useTranslation('medicalLeaveRequest');
    const userApi: UserApi = useContainer(UserApi);
    const toastHandler: ToastStateHandler = useContainer(ToastStateHandler);

    const deleteMedicalLeaveRequest = (id: string, callback: ICallback) => {
        const { exec, abort } = userApi.deleteMedicalLeaveRequest({
            params: { id },
            onSuccess: () => {
                toastHandler.push('success', t('notifications.deleteMedicalLeaveTitle'), t('notifications.deleteMedicalLeaveSucceededMessage'));
                if (callback.onSuccess) callback.onSuccess();
            },
            onError: error => {
                toastHandler.push('error', t('notifications.deleteMedicalLeaveTitle'), t('notifications.deleteMedicalLeaveFailedMessage'));
                if (callback.onError) callback.onError?.(error);
                else console.error(error);
            },
        });
        exec();
        return abort;
    };

    return { deleteMedicalLeaveRequest };
};

export default useHttpDeleteMedicalLeaveRequest;
